import { Table } from 'antd';
import { useContext, useMemo } from 'react';

import type { ModelClientField } from '@app/api/ClientFields';
import { Error403Unauthorized } from '@app/components';
import { HeaderContext } from '@app/providers';

import { ClientFieldModal } from './components/ClientFieldModal/ClientFieldModal';
import { getClientFieldsColumns } from './data/getClientFieldsColumns';
import { useClientFields } from './hooks/useClientFields';
import { useClientFieldsEffects } from './hooks/useClientFieldsEffects';

import type { FC } from 'react';

import './styles/ClientFields.scss';

export const ClientFields: FC = () => {
  const {
    fields,
    isLoading,
    isEditingFieldLoading,
    isSubmitting,
    isModalOpen,
    editingField,
    form,
    canView,
    canEdit,
    canDelete,
    isMobile,
    openCreateModal,
    openEditModal,
    closeModal,
    submitForm,
    deleteField,
  } = useClientFields();

  const { setHeader } = useContext(HeaderContext);

  useClientFieldsEffects({ setHeader, openCreateModal });

  const columns = useMemo(
    () =>
      getClientFieldsColumns({
        onEdit: openEditModal,
        onDelete: deleteField,
        canEdit,
        canDelete,
      }),
    [openEditModal, deleteField, canEdit, canDelete]
  );

  if (!canView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="ClientFields">
      <Table<ModelClientField>
        className="ClientFields__table"
        columns={columns}
        dataSource={fields}
        rowKey="Id"
        loading={isLoading}
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 480 }}
        pagination={false}
      />
      <ClientFieldModal
        isOpen={isModalOpen}
        editingField={editingField}
        form={form}
        isSubmitting={isSubmitting}
        isLoading={isEditingFieldLoading}
        onSubmit={submitForm}
        onCancel={closeModal}
      />
    </div>
  );
};
